import { useEffect, useMemo, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteContext, lenisRef } from "./lib/site";
import { content } from "./content";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Approach } from "./components/Approach";
import { WhyUs } from "./components/WhyUs";
import { Industries } from "./components/Industries";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const initialLang = () => (localStorage.getItem("stravion-lang") === "ar" ? "ar" : "en");

function App() {
  const [lang, setLang] = useState(initialLang);
  const [service, setService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("stravion-lang", lang);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: content[lang], isRTL: lang === "ar", service, setService }), [lang, service]);

  return (
    <SiteContext.Provider value={value}>
      <div className="grain" data-testid="site-root">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Approach />
          <WhyUs />
          <Industries />
          <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#131822", border: "1px solid rgba(197,160,89,0.3)", color: "#F8FAFC" } }} />
      </div>
    </SiteContext.Provider>
  );
}

export default App;
